import { render, staticRenderFns } from "./OauthClient.vue?vue&type=template&id=11d26b9c"
import script from "./OauthClient.vue?vue&type=script&lang=js"
export * from "./OauthClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports